import { Image } from 'expo-image';
import { StyleSheet, TouchableOpacityProps, View } from 'react-native';

import { candleIcon } from '@/assets/images/icons';

import Text from '../Text';
import CircularProgressButton from './CircularProgressButton';

interface LightRatingButtonProps extends TouchableOpacityProps {
  lightRatingValue: number | null;
  variant?: 'small' | 'medium' | 'large' | 'xlarge';
}

const LightRatingButton = ({ lightRatingValue = null, variant = 'small', ...props }: LightRatingButtonProps) => {
  const styles = useStyle(variant, lightRatingValue !== null);

  return (
    <CircularProgressButton {...props} size={getSize(variant)} value={lightRatingValue !== null ? lightRatingValue : 0}>
      <View style={styles.lightRatingMainContainer}>
        <View style={styles.lightRatingContent}>
          <Image source={candleIcon} style={styles.lightRatingFlameIcon} contentFit="contain" />
          {lightRatingValue !== null && (
            <Text fontWeight="700" style={styles.lightRatingValue}>
              {Number(lightRatingValue).toFixed(2).replace(/\.00$/, '')}
            </Text>
          )}
        </View>
      </View>
    </CircularProgressButton>
  );
};

export default LightRatingButton;

const getSize = (variant: string): number => {
  switch (variant) {
    case 'small':
      return 54;

    case 'medium':
      return 80;

    case 'large':
      return 108;

    case 'xlarge':
      return 194;

    default:
      return 54;
  }
};

const useStyle = (variant: string, hasValue: boolean) => {
  const getTopPosition = (): number => {
    switch (variant) {
      case 'small':
        return 8;

      case 'medium':
        return 12;

      case 'large':
        return 18;

      case 'xlarge':
        return 36;

      default:
        return 8;
    }
  };

  const getIconSize = (): number => {
    switch (variant) {
      case 'small':
        return 22;

      case 'medium':
        return 40;

      case 'large':
        return 60;

      case 'xlarge':
        return 75;

      default:
        return 8;
    }
  };

  const getFontSize = () => {
    switch (variant) {
      case 'xlarge':
        return 35;
      default:
        return 10;
    }
  };

  const styles = StyleSheet.create({
    lightRatingMainContainer: {
      zIndex: 10,
      position: 'absolute',
      top: getTopPosition(),
      bottom: 0,
      left: 0,
      right: 0
    },

    lightRatingContent: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2
    },

    lightRatingFlameIcon: {
      height: getIconSize(),
      width: getIconSize(),
      zIndex: 3
    },

    lightRatingValue: {
      fontSize: getFontSize(),
      fontStyle: 'normal',
      color: 'white',
      zIndex: 3
    }
  });

  return styles;
};
